/**
 * Plot View / Valuation Stage View switch — same two-mode concept as
 * `PlotMatrix.tsx`'s own `viewMode` Segmented control.
 */
import React from "react";
import { Segmented } from "antd";

export type PlotMatrixJsonViewMode = "plot" | "stage";

export interface PlotMatrixJsonViewToggleProps {
  value: PlotMatrixJsonViewMode;
  onChange: (value: PlotMatrixJsonViewMode) => void;
}

const PlotMatrixJsonViewToggle: React.FC<PlotMatrixJsonViewToggleProps> = ({
  value,
  onChange,
}) => (
  <Segmented
    value={value}
    onChange={(next) => onChange(next as PlotMatrixJsonViewMode)}
    options={[
      { label: "Plot View", value: "plot" },
      { label: "Valuation Stage View", value: "stage" },
    ]}
  />
);

export default PlotMatrixJsonViewToggle;
